import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/History.css';

const URL_BACKEND = process.env.REACT_APP_URL_BACKEND;

const modeFields = {
  item: { idCol: 'id_item', nameCol: 'nom_item' },
  game: { idCol: 'id_jeu', nameCol: 'nom_jeu' },
  character: { idCol: 'id_personnage', nameCol: 'nom_personnage' },
  sword: { idCol: 'id_epee', nameCol: 'nom_epee' },
};

function History() {
  const { t } = useTranslation();
  // on récupère le mode depuis l'URL (item, game, character, sword)
  const { mode } = useParams();
  console.log('History component rendered with mode:', mode);
  const [puzzles, setPuzzles] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
  setPuzzles(null);
  setError(false);
  fetch(`${URL_BACKEND}/api/history/${mode}`)
    .then(r => {
      if (!r.ok) throw new Error('Not found');
      return r.json();
    })
    .then(data => {
      console.log('Fetched puzzles:', data);
      setPuzzles(data);
    })
    .catch(() => setError(true));
}, [mode]);

  if (error) return <p>Erreur de chargement de l'historique.</p>;
  if (!puzzles) return null;

  const fields = modeFields[mode];

  return (
    <div className="history">
      <h1>{t('history.title', { mode })}</h1>
      {puzzles.length === 0 ? (
        <p>{t('history.no_puzzles')}</p>
      ) : (
        <ul>
          {puzzles.map(puzzle => (
            <li key={`${puzzle[fields.idCol]}-${puzzle.id_historique}`}>
              <Link to={`/${mode}/${puzzle.id_historique}`}>
                #{puzzle.id_historique}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default History;